import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import numeral from 'numeral';
import { format } from 'date-fns';

export function pdfFromQuotation(quotation) {
    const documentWidth = 210;
    const documentHeight = 297;
    const margin = 10;
    const lineHeight = 4;
    const defaultFontSize = 8;
    const defaultSpacer = 16;
    const logoHeight = 20;
    const logoWidth = 26;
    const footerHeight = 20;
    const pageBreak = 210
    let prevHeight = 0;
    let hColStart = 105;
    let vColStart = 0;

    // A4 Portrait Dimensions 210 x 297
    const { attributes: invoiceInfo } = quotation;
    const { facturacion } = invoiceInfo;
    const { entrega } = invoiceInfo;
    const { fabricacion } = invoiceInfo;
    const { pago } = invoiceInfo;
    const { persona_recibe } = invoiceInfo;
    const { telefono_recibe } = invoiceInfo;

    const headerLineOne = `COTIZACIÓN ${invoiceInfo?.folio}${invoiceInfo?.clave_cliente != null ? ` | ID-SAP: ${invoiceInfo.clave_cliente}` : ''}`;
    const headerLineTwo = 'METAL Y PANEL INDUSTRIAL PANEL DEPOT S.A DE C.V';

    const footerLineOne = 'RIO NILO # 499 COL. SAN CARLOS C.P. 44460 GUADALAJARA, JAL.';
    const footerLineTwo = 'FLOR DE HORTENSIA #20 ZAPOTE DEL VALLE, CP 4567, TLAJOMULCO, JAL.';

    const politicas = [
        "Entrega de productos no inlcuye maniobras de descarga.",
        "Material viaja sin seguro, es indispensable solicitarlo con anticipación.",
        "Sólo se entrega material con depósito en Firme.",
        "Toda cancelación puede generar cargos por penalización, sobre todo si el material ya está fabricado o en proceso de embarque.",
        "Cambio de precios y condiciones sin previo aviso. Se requiere anticipo para cerrar la venta.",
    ];

    const bankData = {
        name: 'santander',
        account: '65508128001',
        clabe: '014320655081280012'
    };

    const doc = new jsPDF();

    let myImage = new Image();
    myImage.src = '/logo.png';
    myImage.onload = () => {
        // ----- HEADER -----
        doc.addImage(myImage, 'PNG', margin, margin, logoWidth, logoHeight);
        doc.setFontSize(defaultFontSize + 4);
        doc.text(headerLineOne, resolveTextToRight(doc.getTextWidth(headerLineOne)), resolveHeight(margin));
        doc.setFontSize(defaultFontSize);
        doc.text(formatISO(invoiceInfo?.fecha_elaboracion), resolveTextToRight(doc.getTextWidth(formatISO(invoiceInfo?.fecha_elaboracion))), resolveHeight(prevHeight + lineHeight / 2));
        doc.setFont('Helvetica', 'Bold');
        doc.setFontSize(defaultFontSize + 4);
        doc.text(headerLineTwo, resolveCenteredText(doc.getTextWidth(headerLineTwo)), resolveHeight(prevHeight + lineHeight));

        // ----- BODY -----
        doc.setFont('Helvetica', '');
        doc.setFontSize(defaultFontSize);
        // ----- CLIENT, INVOICE INFO -----
        doc.text(resolveNullableField("facturado a", invoiceInfo?.nombre_cliente), margin, resolveHeight(logoHeight + margin + lineHeight));
        // Capture current height to start second column on th same place.
        vColStart = logoHeight + margin + lineHeight;
        doc.text(resolveNullableField("e-mail", invoiceInfo?.correo_cliente), margin, resolveHeight(prevHeight));
        doc.text(resolveNullableField("tels", invoiceInfo?.telefono_cliente), margin, resolveHeight(prevHeight));
        doc.text(resolveNullableField("rfc", facturacion?.rfc), margin, resolveHeight(prevHeight));
        // Second column
        doc.text(resolveNullableField("fecha", invoiceInfo?.fecha_elaboracion == null ? null : formatISO(invoiceInfo?.fecha_elaboracion)), hColStart, resolveHeight(vColStart));
        doc.text(resolveNullableField("folio", invoiceInfo?.folio), hColStart, resolveHeight(prevHeight));
        // ----- DELIVERY INFO -----
        doc.text(resolveNullableField("entrega", entrega), margin, resolveHeight(prevHeight + defaultSpacer));
        vColStart = prevHeight;
        doc.text(resolveNullableField("fabricacion", fabricacion), margin, resolveHeight(prevHeight));
        doc.text(resolveNullableField("pago", pago), margin, resolveHeight(prevHeight));
        // Second column
        doc.text(resolveNullableField("recibe mat.", persona_recibe), hColStart, resolveHeight(vColStart));
        // doc.text(resolveNullableField("fecha y hora", entrega?.fecha == null ? null : formatISO(entrega?.fecha)), hColStart, resolveHeight(prevHeight));
        doc.text(resolveNullableField("tel", telefono_recibe), hColStart, resolveHeight(prevHeight));
        // ----- OBSERVATIONS -----
        doc.text(resolveNullableField("observaciones", invoiceInfo?.observaciones), margin, resolveHeight(prevHeight));

        // ----- TABLE -----
        const prodData = resolveProductData({
            products: invoiceInfo?.productos,
            services: invoiceInfo?.servicios,
            subtotal: invoiceInfo?.subtotal,
            iva: invoiceInfo?.iva,
            total: invoiceInfo?.total
        });

        doc.autoTable({
            headStyles: { fillColor: [208, 2, 27], fontStyle: 'bold', fontSize: defaultFontSize },
            bodyStyles: { fontSize: defaultFontSize },
            head: getProductTableHeaders(),
            body: prodData,
            startY: resolveHeight(prevHeight),
            margin: { top: margin, right: margin, bottom: footerHeight, left: margin }
        });

        if (doc.previousAutoTable.finalY > pageBreak) {
            doc.addPage();
            doc.text(resolveNullableField('banco', bankData.name), margin, resolveHeight(margin));
            doc.text(resolveNullableField('cuenta', bankData.account), margin, resolveHeight(prevHeight));
            doc.text(resolveNullableField('clabe', bankData.clabe), margin, resolveHeight(prevHeight));

            doc.text("COMENTARIOS", margin, resolveHeight(prevHeight + lineHeight));
            doc.setDrawColor(255, 182, 193);
            doc.rect(margin, resolveHeight(prevHeight), documentWidth - margin * 2, 16, 'S');
            doc.setFont('Helvetica', 'Bold');
            doc.text(
                resolveNullableField("vendedor", invoiceInfo?.vendedor?.data?.attributes?.nombre_completo),
                margin,
                resolveHeight(prevHeight + 16)
            );
            doc.text(
                resolveNullableField("correo", invoiceInfo?.vendedor?.data?.attributes?.email),
                margin,
                resolveHeight(prevHeight)
            );
            doc.text(
                'AUTORIZÓ',
                margin,
                resolveHeight(prevHeight + lineHeight)
            );
            doc.line(margin, prevHeight + lineHeight * 2, documentWidth / 2 - 30, prevHeight + lineHeight * 2, 'S');
            doc.text(resolveNullableField("sr(a)", invoiceInfo?.nombre_cliente), margin, resolveHeight(prevHeight + lineHeight * 2));
            doc.text("POLÍTICAS DE VENTA", margin, resolveHeight(prevHeight + lineHeight * 2));
            doc.setFont('Helvetica', '');
            doc.setFontSize(defaultFontSize);
            for (const p of politicas) {
                doc.text(p, margin, resolveHeight(prevHeight));
            }
            addFooters();
        } else {
            doc.text(resolveNullableField('banco', bankData.name), margin, resolveHeight(doc.previousAutoTable.finalY + lineHeight));
            doc.text(resolveNullableField('cuenta', bankData.account), margin, resolveHeight(prevHeight));
            doc.text(resolveNullableField('clabe', bankData.clabe), margin, resolveHeight(prevHeight));

            doc.text("COMENTARIOS", margin, resolveHeight(prevHeight + lineHeight));
            doc.setDrawColor(255, 182, 193);
            doc.rect(margin, resolveHeight(prevHeight), documentWidth - margin * 2, 16, 'S');
            doc.setFont('Helvetica', 'Bold');
            doc.text(
                resolveNullableField("vendedor", invoiceInfo?.vendedor?.data?.attributes?.nombre_completo),
                margin,
                resolveHeight(prevHeight + 16)
            );
            doc.text(
                resolveNullableField("correo", invoiceInfo?.vendedor?.data?.attributes?.email),
                margin,
                resolveHeight(prevHeight)
            );
            doc.text(
                'AUTORIZÓ',
                margin,
                resolveHeight(prevHeight + lineHeight)
            );
            doc.line(margin, prevHeight + lineHeight * 2, documentWidth / 2 - 30, prevHeight + lineHeight * 2, 'S');
            doc.text(resolveNullableField("sr(a)", invoiceInfo?.nombre_cliente), margin, resolveHeight(prevHeight + lineHeight * 2));
            doc.text("POLÍTICAS DE VENTA", margin, resolveHeight(prevHeight + lineHeight * 2));
            doc.setFont('Helvetica', '');
            doc.setFontSize(defaultFontSize);
            for (const p of politicas) {
                doc.text(p, margin, resolveHeight(prevHeight));
            }
            addFooters();
        }

        doc.save(`cotizacion_${formatISO(new Date().toISOString())}_${invoiceInfo?.folio ?? ''}`);
    }

    // Helper functions

    function resolveHeight(init) {
        const newHeight = init + lineHeight;
        prevHeight = newHeight;
        return newHeight;
    }

    function resolveNullableField(identifier, value) {
        return identifier.toUpperCase() + ': ' + (value ? value.toString().toUpperCase() : '---');
    }

    function resolveProductData(config) {
        const { products } = config;
        const { services } = config;
        const { subtotal } = config;
        const { iva } = config;
        const { total } = config;

        let tableData = [];

        if (products != null) {
            for (const p of products) {
                tableData.push([
                    toFormattedNumberWithCommas(p.cantidad),
                    p?.selected_unit?.referencia ?? "---",
                    p.descripcion,
                    toFormattedNumber(p.largo),
                    toCurrency(p.precio_unitario_final),
                    toCurrency(p.total_local),
                    p.peso_calculado == 0 ? "---" : toFormattedNumberWithCommas(p.peso_calculado),
                ]);
            }
        }

        if (services != null) {
            for (const p of services) {
                tableData.push([
                    toFormattedNumberWithCommas(p.cantidad),
                    p.unidad ?? "---",
                    p.descripcion ? p.descripcion.toUpperCase() : "---",
                    "---",
                    toCurrency(p.precio_unitario_calculado),
                    toCurrency(p.precio_unitario_final),
                    toCurrency(p.total_local),
                    "---",
                ]);
            }
        }
        tableData.push(['', '', '', '', '', '', '']);
        tableData.push(['', '', '', '', '', 'SUBTOTAL', toCurrency(subtotal)]);
        tableData.push(['', '', '', '', '', 'IVA', toCurrency(iva)]);
        tableData.push(['', '', '', '', '', 'TOTAL', toCurrency(total)]);
        return tableData;
    }

    function toCurrency(value) {
        if (value == null || typeof value !== "number") {
            return "---";
        }

        let formatter = new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN'
        });

        return formatter.format(value);
    }

    function toFormattedNumber(value) {
        if (value == null || typeof value !== "number") {
            return "---";
        }
        return numeral(value).format("0.00");
    }

    function toFormattedNumberWithCommas(value) {
        if (value == null || typeof value !== "number") {
            return "---";
        }

        return numeral(value).format("0,0.00");
    }

    function getProductTableHeaders() {
        return [[
            'CANTIDAD', // 0
            'U', // 1
            'DESCRIPCIÓN', // 3
            'LARGO', // 2
            'PRECIO FINAL', // 6
            'VALOR TOTAL', // 7
            'PESO', // 4
        ]];
    }

    function resolveCenteredText(length) {
        if (length == null) {
            console.warn("Missing required parameters to center text.");
            return 0;
        }

        const docMiddle = documentWidth / 2;
        const textMiddle = length / 2;

        return docMiddle - textMiddle;
    }

    function resolveTextToRight(length) {
        if (length == null) {
            console.warn("Missing required parameters to align text.");
            return 0;
        }

        return (documentWidth - margin) - length;
    }

    function addFooters() {
        const pageCount = doc.internal.getNumberOfPages();
        const footerMargin = 1;

        for (let i = 0; i < pageCount; i++) {
            doc.setFillColor(208, 2, 27);
            doc.rect(0, documentHeight - footerHeight, documentWidth, footerHeight, 'F');
            doc.setFillColor(255, 182, 193);
            doc.rect(0, documentHeight - footerHeight, documentWidth, footerMargin, 'F');

            doc.setFont('Helvetica', 'Bold');
            doc.setFontSize(defaultFontSize);
            doc.setTextColor(255, 255, 255);
            doc.text(footerLineTwo, margin, resolveHeight((documentHeight - footerHeight) + footerMargin));
            doc.text("(33) 3145 6337, (33) 3145 6338, (33) 3699 9963 y (33) 1653 2673", margin, resolveHeight(prevHeight));
            doc.text("www.paneldepot.com", resolveTextToRight(doc.getTextWidth("www.paneldepot.com")), resolveHeight((documentHeight - footerHeight) + footerMargin));
            doc.text("ventas@paneldepot.com", resolveTextToRight(doc.getTextWidth("ventas@paneldepot.com")), resolveHeight(prevHeight));
            doc.text("administracion@paneldepot.com", resolveTextToRight(doc.getTextWidth("administracion@paneldepot.com")), resolveHeight(prevHeight));
        }
    }

    function formatISO(date) {
        const value = new Date(date);
        return `${format(value, "dd-MM-yyyy")}`;
    }
}